<template>
  <div class="fixed top-4 right-4 z-50 space-y-2">
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      :type="toast.type"
      :message="toast.message"
      :duration="toast.duration"
      @close="handleClose(toast.id)"
    />
  </div>
</template>

<script lang="ts" setup>
import Toast from './Toast.vue';
import { useToast } from '@/composables/useToast';

const { toasts, remove } = useToast();

/**
 * 处理 Toast 关闭
 */
const handleClose = (id: number) => {
  remove(id);
};
</script>

